import React, { useState } from 'react';
import { authApi } from '../services/api';

function RegisterForm({ onRegisterSuccess, onClose, onSwitchToLogin, onShowTerms, onShowPrivacy }) {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // 表单验证
    if (!username || !email || !password || !confirmPassword) {
      setError('请填写所有必填字段');
      return;
    }
    
    if (password !== confirmPassword) {
      setError('两次输入的密码不一致');
      return;
    }
    
    if (!agreeTerms) {
      setError('请同意用户协议和隐私政策');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      const response = await authApi.register(username, email, password);
      
      if (response.success) {
        // 注册成功，保存token并通知父组件
        localStorage.setItem('token', response.data.token);
        onRegisterSuccess(response.data.user);
      } else {
        setError(response.error || '注册失败，请稍后再试');
      }
    } catch (err) {
      console.error('Register error:', err);
      setError('注册失败，请稍后再试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-form">
      {error && <div className="error-message">{error}</div>}
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            type="text"
            id="registerName"
            placeholder="用户名"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        
        <div className="form-group">
          <input
            type="email"
            id="registerEmail"
            placeholder="邮箱"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        
        <div className="form-group">
          <input
            type="password"
            id="registerPassword"
            placeholder="密码"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="new-password"
          />
        </div>
        
        <div className="form-group">
          <input
            type="password"
            id="confirmPassword"
            placeholder="确认密码"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            autoComplete="new-password"
          />
        </div>
        
        <div className="form-group">
          <input
            type="checkbox"
            id="agreeTerms"
            checked={agreeTerms}
            onChange={(e) => setAgreeTerms(e.target.checked)}
          />
          <label htmlFor="agreeTerms">
            我已阅读并同意
            <a href="#" id="showTerms" onClick={(e) => { e.preventDefault(); onShowTerms(e); }}>用户协议</a>
            和
            <a href="#" id="showPrivacy" onClick={(e) => { e.preventDefault(); onShowPrivacy(e); }}>隐私政策</a>
          </label>
        </div>
        
        <button 
          type="submit" 
          id="registerSubmit"
          disabled={loading}
        >
          {loading ? '注册中...' : '注册'}
        </button>
      </form>
    </div>
  );
}

export default RegisterForm;